export default __webpack_public_path__ + "static/media/CACHE.669bb0bf.svg";